import React, {useContext} from 'react'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import ConfigContext from '../contexts/configContext'
import DefaultAvatar from '../images/default-avatar.png'
import GetLiveCallPath from './LiveCallPath';

export default function Launcher(
    {
        fullSize,
        onFullSizeChange,
        onStartCall,
        maintenance,
        maintenanceMode
    }
) {
  const config = useContext(ConfigContext)

  const renderFullsize = () => {
    return (
        <div className='live-call-launcher-blurb'>
            <div className='live-call-launcher-close'>
                <CloseIcon
                    onClick={() => onFullSizeChange(false)}
                />
            </div>
            <p>
                {config?.launcher?.introTxt
                    ? config.launcher.introTxt 
                    : "Expert advice from our team via live video chat"
                }
            </p>
            <Button 
                variant="contained"
                onClick={() => onStartCall()}
                size="large"
            >
                {config?.launcher?.startButtonTxt
                    ? config.launcher.startButtonTxt 
                    : "Start Live Call"
                }
            </Button>
        </div>
    ) 
  }

  const renderMaintenanceMessage = () => {
    return (
        <div className='live-call-launcher-blurb'>
            <div className='live-call-launcher-close'>
                <CloseIcon
                    onClick={() => onFullSizeChange(false)}
                />
            </div>
            <p>
                {config?.maintenance?.maintenanceTxt
                    ? config.maintenance.maintenanceTxt 
                    : "Sorry, we are unable to process your request at the moment, please try again later."
                }
            </p>
        </div>
    ) 

  }

  const renderSpeechBubble = () => {
    return (
        <div 
            className='live-call-launcher-speech-bubble'
            onClick={() => {
                if (!fullSize) {
                    onFullSizeChange(true)
                }
            }}
        >
            {config?.launcher?.speechBubbleTxt 
                ? config.launcher.speechBubbleTxt 
                : "Hi, can I help?"
            }
        </div>
    )
  }

  const renderAvatar = () => {
    return (
        <div 
            className='live-call-launcher-avatar'
        >
            <img 
                src={config?.launcher?.avatarUrl
                    ? config.launcher.avatarUrl 
                    : GetLiveCallPath(DefaultAvatar)
                }
                alt="agent avatar"
                onClick={() => {
                    if (!fullSize) {
                        onFullSizeChange(true)
                    }
                }}
            />
            <div className='live-call-launcher-avatar-indicator'/>
        </div>
        )
  }

  return (
    <div className="live-call-launcher">
        {fullSize ? 
            <>
            {maintenance && maintenanceMode == 'message' ?
                renderMaintenanceMessage()
            :
                renderFullsize()
            }
            </> 
        : null}
        {renderAvatar()}
        {!fullSize ? renderSpeechBubble() : null}
    </div>
  )
}
